export default __webpack_public_path__ + "static/media/scan-bold.742db031.svg";